import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface OrderStatusRequest {
    order_idx: number;
}

interface ApiErrorResponse {
    statusCode: number;
    message: string;
}

export const usePutOrderReceipt = (
    successCallback?: () => void,
): UseMutationResult<null, AxiosError<ApiErrorResponse>, OrderStatusRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, AxiosError<ApiErrorResponse>, OrderStatusRequest>({
        mutationFn: async ({ order_idx }: OrderStatusRequest) => {
            try {
                const response = await axios.put(
                    `${enum_api_uri.put_order_receipt_idx}/${order_idx}`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    },
                );
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getSalesCustomerList"] });
            successCallback?.();
        },
    });
};
